import * as React from "react";
import Component from "../../AbstractComponent";
import Constants from "../../../Action/Constants";
import { TableComponent } from "../../Partials/Table/TableComponent";
import { connect } from "react-redux";
import { ActivityTemplateInterface } from "../../../Entity/Entities/Activity/ActivityTemplateInterface";

import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Card from '@material-ui/core/Card';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';

import { PromptDialog } from "../../Partials/Dialog/PromptDialog";

class ActivityTemplates extends Component {
  protected selectedActivityTemplate: ActivityTemplateInterface;

  public state = {
    isDeleteActivityTemplatePopupOpen: false,
    currentActivityTemplate: null,
    anchorEl: null
  };

  constructor(public props) {
    super(props);
  }

  public deleteActivityTemplate = (activityTemplate: ActivityTemplateInterface): any => {
    this.props.dispatch({
      type: Constants.GLOBAL_ACTIVITY_TEMPLATE_DELETE_START,
      payload: {
        activityTemplate: activityTemplate
      }
    });
  }

  protected openMenu = (event: any, activityTemplate: ActivityTemplateInterface): void => {
    this.selectedActivityTemplate = activityTemplate;

    this.setState({
      anchorEl: event.currentTarget
    });
  }

  protected closeMenu = (): void => {
    this.setState({
      anchorEl: null
    });
  }

  public getActivities = (): any => {
    return this.props.app.activityTemplates
      .filter(activityTemplate => !activityTemplate.removed)
      .sort((activityTemplate1: ActivityTemplateInterface, activityTemplate2: ActivityTemplateInterface) => {
        if (activityTemplate1.name.toLowerCase() > activityTemplate2.name.toLowerCase()) {
          return 1;
        }

        if (activityTemplate1.name.toLowerCase() < activityTemplate2.name.toLowerCase()) {
          return -1;
        }

        return  0;
      })
      .map((activityTemplate: ActivityTemplateInterface, index: number) => {
        return (
          <TableRow
            hover
            key={index}
            className={`clickable-entity`}
            onClick={() => {
                this.redirect(`/app/activity-template/update/${activityTemplate.id}`);
              }
            }
          >
            <TableCell style={{width: "24px", paddingLeft: "10px", paddingRight: "5px"}}>
              <div style={{display: "flex", alignItems: "center", justifyContent: "center", paddingTop: "4px"}}>
                <div className="icon icon-ic-activity">
                </div>
              </div>
            </TableCell>
            <TableCell>{activityTemplate.name}</TableCell>
            <TableCell>{activityTemplate.taskTemplates.length}</TableCell>
            <TableCell
              onClick={e => {
                e.stopPropagation();
              }}
            >
              <div>
                <IconButton
                  onClick={e => this.openMenu(e, activityTemplate)}
                >
                  <div className="icon icon-ic-more-vert"></div>
                </IconButton>
                <Menu
                  id="simple-menu"
                  anchorEl={this.state.anchorEl}
                  open={Boolean(this.state.anchorEl) && this.selectedActivityTemplate && this.selectedActivityTemplate.id === activityTemplate.id}
                  onClose={this.closeMenu}
                  disableAutoFocusItem={true}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "center"
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "left"
                  }}
                  getContentAnchorEl={null}
                >
                  <MenuItem
                    onClick={() => {
                      if (this.isUserHasAccess()) {
                        this.redirect(`/app/activity-template/update/${this.selectedActivityTemplate.id}`);
                      } else {
                        this.setState({
                          anchorEl: null
                        })

                        this.props.dispatch({
                          type: Constants.SNACKBAR_ADD_MESSAGE,
                          payload: {
                            message: this.trans("preprocess/cantcreateactivitytemplate-info"),
                            type: "warning"
                          }
                        });
                      }
                    }}
                  >
                    <ListItemIcon><div className="icon icon-ic-edit icon-color"></div></ListItemIcon>
                    <ListItemText>{this.trans("menuitem-open")}</ListItemText>
                  </MenuItem>
                  <MenuItem
                    className="delete-action"
                    onClick={() => {
                      if (this.isUserHasAccess()) {
                        this.setState({isDeleteActivityTemplatePopupOpen: true, currentActivityTemplate: this.selectedActivityTemplate, anchorEl: null})
                      } else {
                        this.setState({
                          anchorEl: null
                        })

                        this.props.dispatch({
                          type: Constants.SNACKBAR_ADD_MESSAGE,
                          payload: {
                            message: this.trans("preprocess/cantcreateactivitytemplate-info"),
                            type: "warning"
                          }
                        });
                      }
                    }}
                  >
                    <ListItemIcon><div className="icon icon-ic-remove icon-color remove-icon"></div></ListItemIcon>
                    <ListItemText>{this.trans("menuitem-delete")}</ListItemText>
                  </MenuItem>
                </Menu>
              </div>
            </TableCell>
          </TableRow>
        );
      });
  }

  public changeShowActivities = (): void => {
    this.saving(() => {
      this.props.dispatch({
        type: Constants.PAGE_SETTINGS_AGENCY_PROFILE_UPDATE_SETTINGS_START,
        payload: {
          preferences: {
            isActivitiesShown: !this.props.app.settings.agency.isActivitiesShown
          }
        }
      });
    });
  }

  public render() {
    return (
      <div style={{width: "100%"}}>
        <div className="component-wrapper no-margin-top no-margin-right">
          <Card className="card no-padding">
            <div className="label-container" style={{display: "flex", justifyContent: "space-between", alignItems: "baseline"}}>
              <div style={{flexDirection: "column"}}>
                <h3 className="card-title">
                  {this.trans("activity-templates")}
                </h3>
                <p
                className="hint-styles"
                style={{
                  fontSize: "14px",
                  color: "#b2b2b2",
                  margin: "0 0 10px 65px"
                }}>
                  {this.trans("create-activities-with-tasks")}
                </p>
              </div>
              <div className="button-container">
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => {
                    if (this.isUserHasAccess()) {
                      this.redirect('/app/activity-template/create');
                    } else {
                      this.props.dispatch({
                        type: Constants.SNACKBAR_ADD_MESSAGE,
                        payload: {
                          message: this.trans("preprocess/cantcreateactivitytemplate-info"),
                          type: "warning"
                        }
                      });
                    }
                  }}
                  style={{marginRight: "25px"}}
                >
                  {this.trans("page/setting-tab/activities-field/newactivity-type/button")}
                </Button>
              </div>
            </div>
            <div style={{padding: "10px 10px 10px 65px"}}>
              <FormControlLabel
                control={
                  <Switch
                    checked={this.props.app.settings.agency.isActivitiesShown}
                    onChange={this.changeShowActivities}
                    color="primary"
                    disabled={(this.props.app.activityTemplates.filter(activityTemplate => !activityTemplate.removed).length === 0) || !this.props.app?.session?.user?.isAdmin?.()}
                  />
                  }
                label={this.trans("page/settings-tab/activitytemplates-switcher/activateactivities-label")}
              />
              <div style={{paddingTop: "20px"}}>
                <div className="hint-styles-wrapper">
                  <div className="hint-styles">{this.trans("page/settings-tab/activitytemplates-hint/foradmin-1")}</div>
                  <div className="hint-styles">{this.trans("page/settings-tab/activitytemplates-hint/foradmin-2")}</div>
                </div>
              </div>
            </div>
            <div className="table-container">
              <TableComponent
                {...this.props}
                paginator={{
                  name: "Activities",
                  path: this.props.app.paginator
                }}
                dispatch={this.props.dispatch}
                headers={[
                  "", this.trans("label-name"), this.trans("number-of-tasks"), ""
                ]}
                entities={this.props.app.activityTemplates}
                className="listing-table activities-listing-table"
                rows={this.getActivities()}
              />
            </div>
          </Card>
        </div>

        <PromptDialog
          {...this.props}
          title={this.trans("delete-activity")}
          content={this.trans("you-are-about-to-delete-activity", {name: this.state.currentActivityTemplate && this.state.currentActivityTemplate.name ? this.state.currentActivityTemplate.name : ""})}
          negativeButtonLabel={this.trans("button-cancel")}
          positiveButtonLabel={this.trans("button-remove")}
          openLeavePrompt={this.state.isDeleteActivityTemplatePopupOpen}
          prioritizeClosing={true}
          onDiscard={() => { this.setState({ isDeleteActivityTemplatePopupOpen: false }); }}
          onSave={() => { this.setState({ isDeleteActivityTemplatePopupOpen: false }, this.deleteActivityTemplate(this.state.currentActivityTemplate)); }}
          positiveButtonStyle={{backgroundColor:"red"}}
          hideCross={true}
        />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    app: state.app,
    component: state.activities,
    globalTypes: state.globalTypes
  };
};

export default connect(mapStateToProps)(
  ActivityTemplates
);
